<div class="c-meta" aria-label="Page">
  <div class="row paginate">
    <div class="col-6 flex-left">
      <span class="central-page mr10">
        <span class="txt-page mr5">{{ $t("componentShowing") }}</span>
      </span>
      <select
        @change="changeLimitQuery"
        v-model="meta.limit"
        class="input limit-change"
        style="border: 1px solid var(--dark-light) !important"
        :disabled="isLoading"
      >
        <option :value="meta.limit" hidden>{{ meta.limit }}</option>
        <option v-for="i in mockOptions" :value="i?.val">{{ i?.label }}</option>
      </select>
      <span class="central-page ml11">
        <!-- <span class="mr5">1</span>
        <span class="mr5">{{ $t("componentTo") }}</span>
        <span class="mr5">{{ meta?.limit || 0 }}</span> -->
        <!-- <span class="mr5">{{ $t("componentOf") }}</span> -->
        <span class="mr5">{{ $t("componentRowPerPageOf") }}</span>
        <span class="mr5">{{ meta?.length || 0 }}</span>
        <span class="txt-page">{{ $t("componentEntries") }}</span>
      </span>
    </div>

    <div class="col-6 flex-right">
      <ul class="justify-content-center page-list">
        <span class="central-page txt-page" style="margin-right: 10px"
          >{{ $t("componentGoTo") }}</span
        >

        <input
          @keyup.enter="goTo(Number(inputPage))"
          @keydown="handleKeyDown"
          @keypress="onkeypress($event)"
          v-model="inputPage"
          type="number"
          min="1"
          class="h29 page-textbox mr20"
          :readonly="isLoading || !data.length || data.length >= meta.length"
        />

        <!-- <button
          v-if="isLoading || !data.length || data.length >= meta.length || inputPage > meta?.totalPage || !inputPage || inputPage === meta?.page"
          class="page-item btn-disabled btn btn-primary mr15 ml5"
          :disabled="isLoading"
        >
          <span class="page-link">{{ $t("componentGo") }}</span>
        </button>
        <button
          v-else
          @click="goTo(Number(inputPage))"
          class="page-item btn btn-primary mr15 ml5"
        >
          <span class="page-link">{{ $t("componentGo") }}</span>
        </button> -->

        <span class="central-page mr10">
          <span class="txt-page">{{ $t("componentPage") }}</span>
          <span class="txt-current-page">{{ meta?.page || 0 }}</span>
          <span class="txt-off">x</span>
          <span class="txt-total-page">{{ meta?.totalPage || 0 }}</span>
        </span>

        <button
          v-if="isLoading || !data.length || data.length >= meta.length ||  Number(meta.page) - 1 <= 0"
          class="page-item btn-disabled btn btn-default prev"
        >
          <span class="page-link">
            <img src="./first-back.svg" alt="">
          </span>
        </button>
        <button
          v-else
          @click="goTo(Number(1))"
          class="page-item btn btn-default prev"
        >
          <span class="page-link">
            <img src="./first-back.svg" alt="">
          </span>
        </button>
        <button
          v-if="isLoading || !data.length || data.length >= meta.length ||  Number(meta.page) - 1 <= 0"
          class="page-item btn-disabled btn btn-default prev"
        >
          <span class="page-link">
            <img src="./back.svg" alt="">
          </span>
        </button>
        <button
          v-else
          @click="goTo(Number(meta.page) - 1)"
          class="page-item btn btn-default prev"
        >
          <span class="page-link">
            <img src="./back.svg" alt="">
          </span>
        </button>
        <button
          v-if="isLoading || !data.length || data.length >= meta.length || meta?.page >= meta?.totalPage"
          class="page-item btn-disabled btn btn-default next"
        >
          <span class="page-link">
            <img src="./next.svg" alt="">
          </span>
        </button>
        <button
          v-else
          @click="goTo(Number(meta.page) + 1)"
          class="page-item btn btn-default next"
        >
          <span class="page-link">
            <img src="./next.svg" alt="">
          </span>
        </button>
        <button
          v-if="isLoading || !data.length || data.length >= meta.length || meta?.page >= meta?.totalPage"
          class="page-item btn-disabled btn btn-default next"
        >
          <span class="page-link">
            <img src="./last-next.svg" alt="">
          </span>
        </button>
        <button
          v-else
          @click="goTo(Number(meta?.totalPage))"
          class="page-item btn btn-default next"
        >
          <span class="page-link">
            <img src="./last-next.svg" alt="">
          </span>
        </button>
      </ul>
    </div>
  </div>
</div>
